import React, { Component } from 'react'
import { connect } from 'react-redux'
import { saveWishes, saveHighlights } from '../../../actions/productsActions'
import { startFetch, endFetch } from '../../../actions/generalActions'
import Product from '../shared/Product'
import ProductCarousel from '../shared/ProductCarousel'
import ContentLayout from '../shared/ContentLayout'
import { ProductsService } from '../../../services/products.service'
import { t } from '../../../i18n'

class WishList extends Component {
  componentDidMount() {
    const { wishes, highlights } = this.props
    if (wishes.length === 0)    this.fetchWishes()
    if (highlights.length === 0) this.fetchHighlights()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.campaign.slug !== this.props.campaign.slug) {
      this.fetchWishes()
      this.fetchHighlights()
    }
  }

  fetchWishes() {
    const { user, campaign } = this.props
    this.props.startFetch()
    ProductsService.getWishes({ client_slug: user.client.slug, campaign_slug: campaign.slug })
      .then(response => {
        this.props.saveWishes(response.data)
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  fetchHighlights() {
    const { user, campaign } = this.props
    this.props.startFetch()
    ProductsService.getHighlights({ client_slug: user.client.slug, campaign_slug: campaign.slug })
      .then(response => {
        this.props.saveHighlights(response.data)
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  render() {
    const { wishes, lastSeenProducts, campaign } = this.props

    return (
      <ContentLayout campaign={campaign} title={t('wishlist.title') || 'Meus Favoritos'}>
        {/* ── Favourites grid ── */}
        <div className="gl-wishlist">
          {wishes.length > 0
            ? (
              <div className="gl-wishlist__grid">
                {wishes.map((item, i) => (
                  <div className="gl-wishlist__item" key={i}>
                    {item.is_new && (
                      <div className="gl-wishlist__new-badge primary-bg navbar-text text-sm px-2 py-1 inline-block rounded mb-1">
                        {t('product.new')}
                      </div>
                    )}
                    <Product item={item} campaign={campaign} />
                  </div>
                ))}
              </div>
            )
            : (
              <div className="gl-wishlist__empty text-center py-16 text-color font-quicksand-light">
                <i className="far fa-heart text-6xl mb-4 block primary-text" />
                <p className="text-xl">{t('wishlist.empty') || 'Ainda não adicionou produtos aos favoritos.'}</p>
              </div>
            )
          }
        </div>

        {/* ── Recently-viewed carousel ── */}
        {lastSeenProducts.length > 0 && (
          <div className="gl-wishlist__carousel mt-16">
            <ProductCarousel
              catalog
              productsNumber={4}
              products={lastSeenProducts}
              campaign={campaign}
              title={t('catalog.viewed-recently')}
              lineColor="var(--color-primary, #82D643)"
            />
          </div>
        )}
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  campaign: state.campaignReducer.campaign,
  wishes: state.productsReducer.wishes,
  highlights: state.productsReducer.highlights,
  lastSeenProducts: state.productsReducer.lastSeenProducts,
})

const mapDispatchToProps = (dispatch) => ({
  saveWishes: (wishes) => dispatch(saveWishes(wishes)),
  saveHighlights: (highlights) => dispatch(saveHighlights(highlights)),
  startFetch: () => dispatch(startFetch()),
  endFetch: () => dispatch(endFetch()),
})

export default connect(mapStateToProps, mapDispatchToProps)(WishList)
